import { render, staticRenderFns } from "./TodosMenu.vue?vue&type=template&id=648da0e7&scoped=true&"
import script from "./TodosMenu.vue?vue&type=script&lang=js&"
export * from "./TodosMenu.vue?vue&type=script&lang=js&"
import style0 from "./TodosMenu.vue?vue&type=style&index=0&id=648da0e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648da0e7",
  null
  
)

export default component.exports